import { IPublicClientApplication } from '@azure/msal-browser';
import { NotificationLocationCode } from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import {
  getNotificationLocations,
  getNotificationTypes,
  getProgramNotifications,
} from './index';

export const createNotificationsApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getNotificationTypes: (instance: IPublicClientApplication) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getNotificationTypes(fetchContext, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getNotificationTypes', isInFlight);
    }
  ),
  getNotificationLocations: (instance: IPublicClientApplication) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getNotificationLocations(fetchContext, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getNotificationLocations', isInFlight);
    }
  ),
  getProgramNotifications: (instance: IPublicClientApplication, programId: number, locationCode: NotificationLocationCode) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getProgramNotifications(fetchContext, programId, locationCode, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getProgramNotifications', isInFlight);
    },
  ),
});
